import { lineLink } from "./App"
import { text } from "./text"

export function quickCallButton() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-soft-primary pb-[env(safe-area-inset-bottom)] text-muted lg:hidden">
      <div className="grid h-16 grid-cols-2">
        <a className="flex items-center justify-center border-r-2 px-2 text-lg font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px]" href="tel:0615498229">
          061-549-8229
        </a>
        <a href={lineLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-2 text-lg font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px]">
          <img src="LINE_Brand_icon.png" alt="" className="h-8 w-8 shrink-0" />
          <span>{text({ en: "Add Friend", th: "เพิ่มเพื่อน" })}</span>
        </a>
      </div>
    </div>
  )
}
